// extracted by mini-css-extract-plugin
export default {"container":"styles_container__VG6Nd","title":"styles_title__Dedo7","subTitle":"styles_subTitle__K2zTo","subTitle2":"styles_subTitle2__zDJK1"};